import { ICON_COLOR } from '../../../Icon'
import {
  getIsRentalPortalApplicantIdentityMasked,
  getRentalPortalApplicantIdentityName,
} from '../../../RentalPortalApplicant'

import { QA_NAME_APPLICANT_PROFILE_HEADER_AVATAR } from './RentalPortalApplicantProfileHeader.constants'

import UserIcon from '../../../../icons/user.svg'

export function getApplicantProfileHeaderAvatarProps({ applicantData, t }) {
  const isMasked = getIsRentalPortalApplicantIdentityMasked(applicantData)
  const maskedNotice = isMasked
    ? t('RentalPortal.ApplicantIdentityMaskedTooltipKey')
    : null

  return {
    Icon: isMasked ? UserIcon : null,
    color: applicantData?.avatar_color,
    editable: false,
    iconProps: { color: ICON_COLOR.SecondaryTextColor },
    qaName: QA_NAME_APPLICANT_PROFILE_HEADER_AVATAR,
    text: getRentalPortalApplicantIdentityName(applicantData),
    tooltip: maskedNotice,
  }
}
